export const apartamentosInitialState = {
  apartamentos: [],
  apartamento: {},
};
